import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/doctor",
    name: "doctor",
    component: () => import("../views/doctor.vue"),
  },
  {
    path: "/clinical",
    name: "clinical",
    component: () => import("../views/clinical.vue"),
  },
  {
    path: "/patient",
    name: "patient",
    component: () => import("../views/patient.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/about.vue"),
  },
  {
    path: "/science",
    name: "science",
    component: () => import("../views/science.vue"),
  },
  {
    path: "/science1",
    name: "science1",
    component: () => import("../views/science1.vue"),
  },
  {
    path: "/science2",
    name: "science2",
    component: () => import("../views/science2.vue"),
  },
  {
    path: "/science3",
    name: "science3",
    component: () => import("../views/science3.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/Register.vue"),
  },
  {
    path: "/forget",
    name: "forget",
    component: () => import("../views/forget.vue"),
  },
  {
    path: "/guan",
    component: () => import("../views/guan.vue"),
  },
  {
    path: "/index",
    name: "index",
    component: () => import("../views/index.vue"),
    meta: {
      needLogin: true,
    },
    children: [
      {
        path: "",
        component: () => import("../views/home.vue"),
      },
      {
        path: "/addCase",
        name: "addCase",
        component: () => import("../views/addCase/AddCase.vue"),
      },
      {
        path: "/exceptionFiltering",
        name: "exceptionFiltering",
        component: () =>
          import("../views/ExceptionFiltering/ExceptionFiltering.vue"),
      },
      {
        path: "/lookCase",
        name: "lookCase",
        component: () => import("../views/addCase/LookCase.vue"),
      },
      {
        path: "/lookCase1",
        name: "lookCase1",
        component: () => import("../views/addCase/LookCase1.vue"),
      },
      {
        path: "/my",
        component: () => import("../views/my/My.vue"),
      },
      {
        path: "/patiInfo",
        name: "patiInfo",
        component: () => import("../views/my/PatiInfo.vue"),
      },
      {
        path: "/my/userUpdate",
        name: "userUpdate",
        component: () => import("../views/my/UserUpdate.vue"),
      },
      {
        path: "/groupMessages",
        name: "groupMessages",
        component: () => import("../views/groupMessages/GroupMessages.vue"),
      },
      {
        path: "/assistantManagement",
        component: () =>
          import("../views/assistantManagement/AssistantManagement.vue"),
      },
      {
        path: "/queryCenter",
        component: () => import("../views/queryCenter/QueryCenter.vue"),
      },
      {
        path: "/queryPatientCenter",
        component: () => import("../views/queryCenter/PatientNewList.vue"),
      },
      {
        path: "/caseQueue",
        component: () => import("../views/caseQueue/CaseQueue.vue"),
      },
      {
        path: "/systemNotice",
        component: () => import("../views/systemNotice/SystemNotice.vue"),
      },
      {
        path: "/systemNotice/officialInfo",
        name: "officialInfo",
        component: () => import("../views/systemNotice/OfficialInfo.vue"),
      },
      {
        path: "/patientList",
        component: () => import("../views/queryCenter/PatientList.vue"),
      },
      {
        path: "/test",
        component: () => import("../views/test.vue"),
      },
      {
        path: "/index/twowayReferral",
        name: "twowayReferral",
        // component: () => import("../views/twowayReferral/TwowayReferral.vue"),
        component: () =>
          import("../views/twowayReferral/components/NotYetOpen.vue"),
      },
      {
        path: "/index/twowayReferral/patientList",
        name: "patientList",
        component: () =>
          import("../views/twowayReferral/components/PatientList.vue"),
      },
      {
        path: "/bookingManagement",
        component: () =>
          import("../views/bookingManagement/bookingManagement.vue"),
      },
      {
        path: "/reservationAvailable",
        component: () =>
          import("../views/bookingManagement/reservationAvailable.vue"),
      },
      {
        path: "/toExamine",
        component: () => import("../views/bookingManagement/toExamine.vue"),
      },
      {
        path: "/toExamine1",
        component: () => import("../views/bookingManagement/toExamine1.vue"),
      },
      {
        path: "/appointmentDate",
        component: () =>
          import("../views/bookingManagement/appointmentDate.vue"),
      },
      {
        path: "/scaleManagement",
        component: () => import("../views/scaleManagement/scaleManagement.vue"),
      },

      // scaleManagement
    ],
  },
];

// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  console.log("进入路由守卫", to.meta.needLogin);
  document.title = "中国婴儿癫痫性痉挛综合征协作网";
  // 判断是否需要守卫
  next();
});

export default router;
